import script from "./EmailVerificationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailVerificationView.vue?vue&type=script&setup=true&lang=ts"

import "./EmailVerificationView.vue?vue&type=style&index=0&id=4a7bf20c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7bf20c"]])

export default __exports__